import { MapTo } from "@adobe/aem-react-editable-components";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
import { SurveyMonkey } from "./SurveyMonkey";
export const surveyEditConfig = {
    emptyLabel: "SurveyMonkey",
    isEmpty: (props) => !props.scriptUrl,
};
export default MapTo("loyalty/components/survey-monkey")(withAemAuthoring(SurveyMonkey, surveyEditConfig));
